
function message(options) {
    return Swal.fire({
        title: options.title || 'Error',
        html: options.html || 'Oops! Something went wrong.<br>Please try again later.',
        icon: options.icon
    });
}

export default {
    alert: message,

    message,

    error(options) {
        options.icon = 'error';
        return message(options);
    },

    success(options) {
        options.icon = 'success';
        options.title = options.title || 'Success';
        return message(options);
    },

    warning(options) {
        options.icon = 'warning';
        return message(options);
    }
};